angular.module('GlobalHelpersModule').filter "showGender", ->
  (genderCode) ->
    if genderCode == 'M'
      'Male'
    else if genderCode == 'F'
      'Female'
    else
      'Provider did not ask'